export function getApiNameByLevel(products, level) {
  var _products$find;
  return products === null || products === void 0 || (_products$find = products.find(c => c.productLevel === level)) === null || _products$find === void 0 ? void 0 : _products$find.productApiName;
}